import React from 'react';
import { Box, Button, Typography, Fade } from '@mui/material';

const Signup: React.FC = () => {
    return (
        <Fade in={true} timeout={2800}>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                sx={{
                    backgroundColor: '#121212',
                    color: '#ffffff',
                    padding: { xs: 4, md: 10 },
                    textAlign: 'center',
                }}
            >
                <Box sx={{ width: '100%', maxWidth: 600 }}>
                    <Typography
                        variant="h3"
                        gutterBottom
                        sx={{
                            fontSize: { xs: '1.8rem', md: '2.5rem' },
                        }}
                    >
                        Want to know more?
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        sx={{
                            fontSize: { xs: '1rem', md: '1.25rem' },
                            mb: 4,
                        }}
                    >
                        Send us an email
                    </Typography>
                    <Button
                        href="mailto:info@genaisignal.com"
                        variant="outlined"
                        sx={{
                            paddingX: { xs: 2, md: 4 },
                            paddingY: { xs: 1, md: 1.5 },
                            borderColor: '#8378ff',
                            color: '#8378ff',
                            '&:hover': {
                                backgroundColor: '#8378ff',
                                color: '#121212',
                            },
                        }}
                    >
                        GET IN TOUCH
                    </Button>
                </Box>
            </Box>
        </Fade>
    );
};

export default Signup;
